import { CoreInterfaces, DTOs } from "src/core/Models";

export const YearlyInternalDocumentationAndFormalitiesTaskProcessor: CoreInterfaces.ServiceTaskProcessor =
  (appState: CoreInterfaces.AppState, serviceDTO: DTOs.ServiceDTO): void => {
    const tasks = [];
  };
